interface OneTrustInterface {
  key: string | undefined;
}

export const OneTrustSettings : OneTrustInterface = {
  key: process.env.ONE_TRUST_KEY
}
